
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/ralali-financiall",
      function () {
        return require("private-next-pages/services/ralali-financiall/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/ralali-financiall"])
      });
    }
  